module.exports = __webpack_public_path__ + "media/components/users/integrations/images/buildout_email_integration-0a4ce30fea987f6ef7f6072231037a98.svg";